import Grid from '@blocks/Grid'
import { Ring } from '@blocks/Loading'
import MainContainer from '@blocks/MainContainer'
import ArchiveEmpty from '@components/modules/Archive/components/ArchiveEmpty'
import useSalonController from '@customer/api/useSalonController'
import useAuth from '@hooks/useAuth'
import useTitle from '@hooks/useTitle'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import EntriesSection from './components/EntriesSection'
import OpenSection from './components/OpenSection'
import PastSection from './components/PastSection'
import SupportSection from './components/SupportSection'
import empty from './config/empty'

export default function Profile() {
    useTitle("Profile")
    useMainTemplate({ category: "profile" })

    const { user } = useAuth()
    const controller = useSalonController()
    const entries = controller.participating.use(`customer:${user.id}:participating`)
    const open = controller.current.use(`customer:${user.id}:current`)
    const past = controller.past.use(`customer:${user.id}:past`)

    if (isProfileEmpty(entries, open, past))
        return (
            <MainContainer heading="Profile" box={false}>
                <ArchiveEmpty empty={empty} />
            </MainContainer>
        )
    
    return (
        <MainContainer heading="Profile" box={false}>
            {isProfileLoading(entries, open, past) 
                ? <Ring />
                : (
                    <Grid>
                        <EntriesSection salons={entries.data} />
                        <OpenSection salons={open.data} />
                        <PastSection salons={past.data} />
                        <SupportSection />
                    </Grid>
                )}
        </MainContainer>
    )
}

function isProfileLoading(
    entries: Hooks.UseController.Methods.Get.Use.Response<Interfaces.Salon[]>,
    open: Hooks.UseController.Methods.Get.Use.Response<Resources.CurrentSalon[]>,
    past: Hooks.UseController.Methods.Get.Use.Response<Interfaces.Salon[]>
): boolean {
    const atLeastOneDataExists = Boolean(entries.data?.length || open.data?.length || past.data?.length)
    const atLeastOneDataLoading = (entries.status === "loading" || open.status === "loading" || past.status === "loading")
    if (atLeastOneDataExists) return false
    return atLeastOneDataLoading
}

function isProfileEmpty(
    entries: Hooks.UseController.Methods.Get.Use.Response<Interfaces.Salon[]>,
    open: Hooks.UseController.Methods.Get.Use.Response<Resources.CurrentSalon[]>,
    past: Hooks.UseController.Methods.Get.Use.Response<Interfaces.Salon[]>
): boolean {
    return entries.status !== "loading" && !entries.data?.length
        && open.status !== "loading" && !open.data?.length
        && past.status !== "loading" && !past.data?.length
}